<div role="main" class="main">

  <section class="page-header">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <ul class="breadcrumb">
            <li><a href="#">Anasayfa</a></li>
            <li class="active">Gizlilik ve Güvenlik</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h1>Gizlilik ve Güvenlik</h1>
        </div>
      </div>
    </div>
  </section>


  <div class="container">
    <div class="row mt-xlg">
      <div class="col-md-12">
        <h2><strong>Gizlilik</strong> ve <strong>Güvenlik</strong></h2>
        <div style="font-size: 16px; ">
          <p><strong>ÜYELİK BİLGİLERİNİZİN GİZLİLİĞİ VE GÜVENLİĞİ</strong></p>
          <p>Ürün satın almak için girmiş olduğunuz tüm bilgiler, İntestech Akıllı Çözümler Ltd. Şti. tarafından 3. firma veya kişilerle paylaşılmayacaktır.</p>


          <p>Firmamız bazı dönemlerde müşterilerine ve üyelerine kampanya bilgileri, yeni ürünler hakkında bilgiler, promosyon bilgileri gönderebilir.</p>


          <p>Verdiğiniz tüm bilgiler fatura amaçlı kullanılacaktır ve gereği halinde bize ulaşarak değiştirtebilirsiniz. Üye giriş bilgilerinizi güvenli koruduğunuz takdirde başkalarının sizinle ilgili bilgilere ulaşması ve bunları değiştirmesi mümkün değildir. Sitemiz SSLgüvenlik sistemi ile korunmaktadır.</p>



          <p><strong>KREDİ KARTI GÜVENLİĞİ</strong></p>


          <p>Şirketimiz, alışveriş sitelerimizden alışveriş yapan kredi kartı sahiplerinin güvenliğini ilk planda tutmaktadır. Kredi kartı bilgileriniz hiçbir şekilde sistemimizde saklanmamaktadır.</p>


          <p>Şirketimiz bünyesinde yapacağınız tüm işlemler iyzico ödeme sitemi ile yapılmaktadır. Girdiğiniz kart bilgilerinizin tamamı bizim sistemimize değil iyziconun güvenli ödeme sistemi üzerinden ilerletilir. Dolayısıyla iyzico sisteminin tüm güvenlik kalkanları sizleri korumuş olur.</p>


          <p>Bilgi hattı veya müşteri hizmetleri servisi bulunan veaçık adres ve telefon bilgilerinin belirtildiği sistemler günümüzde daha fazla tercih edilmektedir. Bu sebeple aklınıza takılan bütün konular hakkında detaylı bilgi alabilir, firmamız ve hizmetlerimizin güvenirliği konusunda daha sağlıklı bilgi edinebilirsiniz.</p>



          <p><strong>Not:</strong>İnternet alışveriş sitelerinde firmanın açık adresinin ve telefonun yer almasına dikkat edilmesini tavsiye ediyoruz. Alışveriş yapacaksanız alışverişinizi yapmadan ürünü/hizmeti aldığınız mağazanın bütün telefon / adres bilgilerini not edin. Eğer güvenmiyorsanız alışverişten önce telefon ederek teyit edin. Intes Technology’e ait tüm online sitelerimizde firmamıza ait tüm bilgiler ve firma yeri belirtilmiştir.</p>


          <p><strong>MAİL ORDER KREDİ KART BİLGİLERİ GÜVENLİĞİ</strong></p>
          <p>Kredi kartı mail-order yöntemi ile bize göndereceğiniz kimlik ve kredi kart bilgileriniz firmamız tarafından gizlilik prensibine göre saklanacaktır. Bu bilgiler olası banka ile oluşubilecek kredi kartından para çekim itirazlarına karşı 60 gün süre ile bekletilip daha sonrasında imha edilmektedir. Sipariş ettiğiniz ürünlerin bedeli karşılığında bize göndereceğiniz tarafınızdan onaylı mail-order formu bedeli dışında herhangi bir bedelin kartınızdan çekilmesi halinde doğal olarak bankaya itiraz edebilir ve bu tutarın ödenmesini engelleyebileceğiniz için bir risk oluşturmamaktadır.</p>


          <p><strong>E-POSTA GÜVENLİĞİ</strong></p>

          <p>Firmamız Müşteri Hizmetleri’ne, herhangi bir siparişinizle ilgili olarak göndereceğiniz e-postalarda, asla kredi kartı numaranızı veya şifrelerinizi yazmayınız. E-postalarda yer alan bilgiler üçüncü şahıslar tarafından görülebilir. Şirketimiz e-postalarınızdan aktarılan bilgilerin güvenliğini hiçbir koşulda garanti edemez.</p>
        </div>
      </div>
    </div>

  </div>

  <section class="call-to-action call-to-action-default with-button-arrow call-to-action-in-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-12">

        </div>
      </div>
    </div>
  </section>

</div>
